import { DemandeValidationPjRcp } from '@graphql/generated';

import {
  AssureurType,
  PieceJustificativeRcp,
  RcpType,
} from '@lib/models/demande-validation-pj/piece-justificative-rcp.model';

export class DemandeValidationPjRcpMapper {
  public static fromGraphQL(input: DemandeValidationPjRcp[]): PieceJustificativeRcp {
    const rcpResult = {} as PieceJustificativeRcp;

    input.forEach((rcp, i) => {
      if (i === 0) {
        rcpResult.dateDebutValidite = rcp.dateDebutValidite;
        rcpResult.statutJuridiqueId = rcp.statutJuridiqueId!;
        rcpResult.assureurId = rcp.assureurId! as AssureurType;
        rcpResult.rcpType = rcp.rcpType!.map(r => r as RcpType);
      } else {
        rcp.rcpType?.forEach(r => rcpResult.rcpType?.push(r as RcpType));
      }

      if (rcp.rcpType!.includes('RcpImmobilier')) {
        rcpResult.dateFinValiditeImmo = rcp.dateFinValidite;
      } else {
        rcpResult.dateFinValidite = rcp.dateFinValidite;
      }
    });

    return rcpResult;
  }
}
